export enum LocalStorageKeys {
  COPIED_DRUG = 'copiedDrug',
  BID_VIEW = 'bidView',
  BIDS_LIST_TABLE_STATE = 'bidListTableState'
}
